import React from "react";
import { Search } from "lucide-react";
import "../../../style/product.css";
import { useSelector } from "react-redux";

const SearchBar = ({ placeholder, onSearch, onFilter }) => {
  const { isPartsURL, isAccessoriesURL } = useSelector((state) => state.domain);
  return (
    <div className="search-bar-container">
      <div className="product-search-bar">
        <Search className="product-search-icon" />
        <input
          type="text"
          placeholder={placeholder}
          className={`${
            isPartsURL
              ? "product-search-input-parts"
              : isAccessoriesURL
              ? "product-search-input-acc"
              : "product-search-input"
          }`}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      {/* <button className="product-filter-button" onClick={onFilter}>
        <FilterIcon />
        Filters
      </button> */}
    </div>
  );
};

export default SearchBar;
